import { faCalendarAlt } from "@fortawesome/pro-regular-svg-icons";

import { EventConfigEnriched } from "src/clients/features-control";
import { Pill } from "src/design-system/Pill";
import { Tooltip } from "src/design-system/Tooltip";

export const EventPill: React.FC<{
  resource: EventConfigEnriched;
}> = ({ resource }) => {
  return (
    <Tooltip placement="bottom" title={resource.display_name_singular} asChild>
      <Pill size="sm" variant="gray" fullWidth>
        <Pill.Icon icon={faCalendarAlt} />
        <Pill.Text>{resource.display_name_singular}</Pill.Text>
      </Pill>
    </Tooltip>
  );
};
